import { useMemo, useEffect } from 'react';
import { useAuthentication } from '../contexts/AuthContext';
import { SiftServiceApi } from '../services/mycaiApis/SiftServiceApi';
import { siftApiConfig } from "../configs/siftApiConfig";
import { debugLog } from '../configs/loggingConfig';

export const useSiftApiService = () => {
    const {
        isAuthenticated,
        apiAccessToken,
        refreshAccessToken
    } = useAuthentication();

    // Use useMemo to create a memoized instance of the service
    const apiServiceClient = useMemo(() => {
        debugLog.log("[USESIFTAPI] configs are {conf}", siftApiConfig)
        return new SiftServiceApi({
            baseURL: siftApiConfig.baseURL,
            accessToken: apiAccessToken,
            refreshAccessTokenFunction: refreshAccessToken,
        });
    }, []); // Empty dependency array ensures the service is created only once

    // Use useEffect to update the access token when it changes
    useEffect(() => {
        if (apiAccessToken) {
            apiServiceClient.updateAccessToken(apiAccessToken);
        }
    }, [apiAccessToken, isAuthenticated, apiServiceClient]);

    return apiServiceClient;
};
